// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.y7Nx7Cr1TtmW4ASo0VY5,
.y7Nx7Cr1TtmW4ASo0VY5 p,
.y7Nx7Cr1TtmW4ASo0VY5 span,
.y7Nx7Cr1TtmW4ASo0VY5 div,
.y7Nx7Cr1TtmW4ASo0VY5 label,
.y7Nx7Cr1TtmW4ASo0VY5 td,
.y7Nx7Cr1TtmW4ASo0VY5 th,
.y7Nx7Cr1TtmW4ASo0VY5 input,
.y7Nx7Cr1TtmW4ASo0VY5 textarea,
.y7Nx7Cr1TtmW4ASo0VY5 select {
  font-family: 'Titillium Web', sans-serif !important;
}

.jvBE8mURC_IdWYLHnXU4 {
    display: inline-block !important;
    height: auto !important;
    opacity: 1 !important;
    position: relative !important;
    pointer-events: auto !important;
    font-size: 14px !important;
    height: 26px !important;
    margin-bottom: 0 !important;
    border: none !important;
    border-bottom: 1px solid #9e9e9e !important;
    padding: 0 !important;
}

.HQ8wAsiqfIbHQEBl8ynE{
    font-size: 14px !important;
    height: 26px !important;
    margin-bottom: 0 !important;
}

.GXlT2h5vFwCjkhqZ1txQ {
    font-weight: bold !important;
}

._2Ox8a9tL99eN3cfadyF {
    font-style: italic !important;
}

.HHT3NdpLsjB3wDdgFcyp {
    font-size: 15px;
}

.xB5kMpnFA4CZPws0ZB3v {
    font-size: 13px;
}

.Yd0yoKgLSxLwynjd1S4M {
    font-size: 14px;
}

.HHT3NdpLsjB3wDdgFcyp {
    font-size: 15px;
}

.ugBt4MGiOb2DFXqpRLyF {
    font-size: 16px;
}

.bw0PA147IW7666x4KZfn {
    font-size: 18px;
}

.De666OCGlMFmMIGbct1l {
    font-size: 20px;
}

.HsXLb9fWOQc7h8XdKMt9 {
    font-size: 22px;
}

.tsX3cXEfxB9qqcyeccJl{
    font-size: 24px;
}

.X_0vxuuWb7FuISJr5ta9 {
    background-color: var(--main-color-first) !important;
}

.xOz6IP2OVhytb_BEd_pa {
    color: var(--main-color-first) !important;
}

.Yssvoyks3Tt_18WYq6Bq {
    color: var(--main-color-text-first) !important;
}

.NBhOJ47WfZNMFovOLBIi {
    margin: 0 !important;
    padding: 0 !important;
}




.ESsTQs0NRD0m9VcdjFKY, .iSN2Ll6PzRlwvLTP3PoR{
    text-align: center;
    display: inline-block;
    width:100%;
}

.ESsTQs0NRD0m9VcdjFKY button {
    margin: 0 10px;
}

.iSN2Ll6PzRlwvLTP3PoR button {
    margin: 0 5px;
}

/* Barre d'actions de modale (Annuler / Valider, etc.) : alignée à droite, compacte */
.TY5Z8TzuMfxmDHE9pkFI {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.bwpRdQT3RKOT7SzoVfaq {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 9px 20px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    border: 1px solid transparent;
    cursor: pointer;
    transition: all 0.15s ease;
}

.XozHTJq9bhHh72v5uSta {
    background-color: #fff;
    border-color: #e2e5e9;
    color: var(--main-color-first);
}

.XozHTJq9bhHh72v5uSta:hover {
    border-color: var(--main-color-first);
    background-color: rgba(45, 117, 135, 0.08);
    color: var(--main-color-first);
}

._a2klPJRZf6smgbAypov {
    background-color: var(--main-color-first);
    border-color: var(--main-color-first);
    color: #fff;
}

._a2klPJRZf6smgbAypov:hover {
    filter: brightness(1.08);
    box-shadow: 0 3px 8px rgba(45, 117, 135, 0.3);
}

.hMbelPjuLFPtLlLjmD7a {
    background-color: var(--main-color-danger);
    border-color: var(--main-color-danger);
    color: #fff;
}

.hMbelPjuLFPtLlLjmD7a:hover {
    filter: brightness(1.05);
    box-shadow: 0 3px 8px rgba(232, 102, 89, 0.35);
}

/* Icône + texte des modales de confirmation */
.BX9AoblnRBlgdKTLJjUS {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    margin: 0 auto 14px;
    border-radius: 50%;
    font-size: 20px;
}

.CJUEtrGlv92oMBAOvNCt {
    background-color: rgba(232, 102, 89, 0.12);
    color: var(--main-color-danger);
}

.S4SgwWg3XjLId_vicJrJ {
    background-color: rgba(45, 117, 135, 0.1);
    color: var(--main-color-first);
}

.qqAvsH5DaVVLlpqyz2sA {
    text-align: center;
    font-size: 15px;
    line-height: 1.5;
    color: #1f2937;
    margin: 0;
}

.UFyv3GYPGJ9NWKpEgM5D {
    display: flex;
    align-items: center;
    gap: 4px; /* espace entre les inputs */
}

.UFyv3GYPGJ9NWKpEgM5D input[type="color"]{
    width: 25px;
    padding: 0px;
    border:none;
}

.Ge_14J3gaFWkhY7L8578 input{
    height: 20px !important;
    font-size: 12px !important;
}

.B532rq_23Pe9TF1PjzKH{
    margin-right: 10px !important;
}

.oeb38Hm18558EJlE2mci{
    margin-left: 10px !important;
    cursor: pointer;
}

.WESAR4jMpRrAWng01XH5{
    margin-bottom: 10px !important;
    text-transform: uppercase;
}

.WESAR4jMpRrAWng01XH5 i{
    color: var(--main-color-first);
}

.RbcSiMrUexvaQLlCo3z8{
    margin: 0px 5px !important;
}

.SLQOkMmQUALpvE7my4r6 {
    display: inline-block;
    cursor: pointer;
}

.pvTKSJb26xmQWrNB4Fix {
    display: block;
    width: 100%;
    cursor: pointer;
}

.mBWaK0cEyX3MFXZ9pmmf {
    position: absolute;
    background: #3f3f3f;
    color: white;
    padding: 10px;
    border-radius: 4px;
    font-size: 15px;
    z-index: 99999999;
    width: max-content;
    opacity: 1;
    text-align: left;
    white-space: pre-line;
    line-height: 0.7;
    /* La bulle recouvre souvent l'icône voisine : elle ne doit pas intercepter les clics */
    pointer-events: none;
}

.iQAPU9z2gCIQaymR3Y39 {
    display: flex;
    align-items: center;
    gap: 8px;
}

.ozZgKYALSYKMZaU6MqxP{
    width: 50vw;
    max-height: 50vh;
    margin-top: 16px;
}

.GCkwjtQqCSEro4HTqmTm{
    position: absolute;
    background-color: rgba(255,255,255,0.1);
    cursor: not-allowed;
    z-index: 10;
    left: 0;
    width: 100%;
    height: 98vh;
}

.n0NMaGXltW_TGBFncncp{
    width: 100%;
    margin-top: 25px;
    font-size: inherit !important;
}

.n0NMaGXltW_TGBFncncp input{
    font-size: inherit !important;
}

.CV7YlqDceeJw5hSAPGeu{    
    font-size: 13px;
    font-style: italic;
}

/* Tabs as buttons : segmented control moderne */
.Qu8WSNbuPEA3VUE0KoTp{
    display: flex;
    align-items: stretch;
    gap: 4px;
    width: 100%;
    box-sizing: border-box;
    margin: 0 0 40px;
    background-color: #eef1f3;
    padding: 4px;
    border-radius: 10px;
    overflow-x: auto;
}

.r1Oj_jrfoXY36ogdYUaX{
    flex: 1 1 auto;
    padding: 8px 6px;
    border-radius: 7px;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    gap: 5px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.1px;
    line-height: 1.2;
    white-space: nowrap;
    transition: all 0.18s ease;
    border: none !important;
    outline: none !important;
}

.r1Oj_jrfoXY36ogdYUaX i{
    font-size: 12px;
    flex-shrink: 0;
}

.y3_2JBurG6RHs77ajIZj{
    background-color: #ffffff !important;
    color: var(--main-color-first) !important;
    box-shadow: 0 1px 4px rgba(16, 24, 40, 0.14);
}

.reQwrlnWK8rXoFECVyHx{
    background-color: transparent !important;
    box-shadow: none !important;
    color: #6b7580 !important;
}

.reQwrlnWK8rXoFECVyHx:hover{
    color: var(--main-color-first) !important;
}

/* Bouton "Retour" (cohérent avec les boutons d'action du tableau) */
.W35qku6J_CWwIAKZfzNq{
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 14px !important;
    height: auto !important;
    background-color: #fff !important;
    border: 1px solid #e2e5e9;
    border-radius: 8px !important;
    color: var(--main-color-first) !important;
    font-size: 13px !important;
    font-weight: 600;
    text-transform: none;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05) !important;
    transition: all 0.15s ease;
}

.W35qku6J_CWwIAKZfzNq:hover{
    background-color: rgba(45, 117, 135, 0.08) !important;
    border-color: var(--main-color-first);
    color: var(--main-color-first) !important;
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(45, 117, 135, 0.18) !important;
}

.W35qku6J_CWwIAKZfzNq i{
    font-size: 12px;
}

/* En-tête compact : nom de la collection + bouton Retour, sur une seule ligne */
/* Collé en haut/gauche/droite du panneau : marges négatives pour compenser le gouttière du col s12 */
.YXjsxIhICXJN1fxVxX3e{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    padding: 20px;
    background: #eef1f3;
    border: none;
    border-radius: 0;
    margin: 0 -0.75rem;
}

/* Variante pour un header affiché dans une modale (gouttière différente du col s12) */
.OnZ394iI4tD8jgOo4DKe{
    margin: -20px -20px 0;
    border-radius: 10px 10px 0 0;
}

.y8YILIq1_WEo9xmFCQhA{
    margin-bottom: 40px;
}

.Y0RpztOUUIIs1qcIW_JX{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    min-width: 0;
}

.za30F0kBx73Ng5KEEmb1{
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #8a949c;
}

.qRzkn2jXbRonbMxHQeH3{
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 15px;
    font-weight: 700;
    color: #1f2937;
    line-height: 1.3;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.qRzkn2jXbRonbMxHQeH3 i{
    font-size: 14px;
    flex-shrink: 0;
}

/* Formulaire de marqueur avec hauteur fixe et scroll */
.CKnnjqHED3JMrngXKPOF {
    height: 100%; /* Hauteur ajustée pour laisser de la place aux boutons */
    overflow-y: auto;
    position: relative;
    padding: 0px 11px;
}

.CjdCaJHB4l96gjlh0z1V {
    padding: 15px;
    background-color: whitesmoke;
    border-radius: 10px;
    border: 1px solid #bdbdbd;
    margin-bottom: 8px;
}

.CjdCaJHB4l96gjlh0z1V input{
    font-size: 14px !important;
    height: 26px !important;
    margin-bottom: 0 !important;
}

.UatwlZ13jcublbROtyUH {
    position: sticky;
    bottom: 0;
    padding: 10px;
    text-align: center;
}

.UatwlZ13jcublbROtyUH button {
    width: 40% !important;
    margin: 0 5px !important;
}

/* Barre d'outils au-dessus du formulaire d'édition d'entité */
.JMS38vIp_srUriL6JFhL {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
}

.JMS38vIp_srUriL6JFhL button {
    width: 36px !important;
    height: 36px !important;
    border-radius: 8px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    margin: 0 !important;
    background-color: #fff !important;
    border: 1px solid #e2e5e9 !important;
    transition: all 0.15s ease !important;
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05) !important;
}

.JMS38vIp_srUriL6JFhL button:hover {
    transform: translateY(-1px) !important;
    border-color: var(--main-color-first) !important;
    background-color: rgba(45, 117, 135, 0.08) !important;
    box-shadow: 0 3px 8px rgba(45, 117, 135, 0.18) !important;
}

.JMS38vIp_srUriL6JFhL button i {
    font-size: 16px !important;
}

/* Grille de sélection du type d'entité à ajouter */
.N2nwKnvqqzWTbYB0g1dm {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    padding: 6px 4px 10px;
}

.VPJscFWb7cbA4tcpMNsz {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 14px 6px;
    background-color: #fff;
    border: 1px solid #e2e5e9;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.15s ease;
}

.VPJscFWb7cbA4tcpMNsz i {
    font-size: 19px;
    color: var(--main-color-first);
}

.VPJscFWb7cbA4tcpMNsz span {
    font-size: 12px;
    font-weight: 600;
    color: #1f2937;
}

.VPJscFWb7cbA4tcpMNsz:hover {
    border-color: var(--main-color-first);
    background-color: rgba(45, 117, 135, 0.08);
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(45, 117, 135, 0.18);
}

/* En-tête de section secondaire (ex : "Modèles") */
.Zpqm6efEmphtU12aZuwC {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    background: #eef1f3;
    border-radius: 10px;
    margin-top: 24px;
    margin-bottom: 16px;
}

.KxSS26dTwN7YQ4ja_Mse {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: var(--main-color-first);
}

/* Barre de statistiques : pleine largeur, sous le header, sans encadré */
.agXHbu9YBIQe6oJKDRnk {
    display: flex;
    align-items: stretch;
    justify-content: space-around;
    margin-top: 8px;
    margin-bottom: 40px;
}

.agXHbu9YBIQe6oJKDRnk .Y043oiZjvuQ3bcKEQapQ {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 8px 4px;
    border-radius: 8px;
    transition: background-color 0.15s ease;
}

.agXHbu9YBIQe6oJKDRnk .Y043oiZjvuQ3bcKEQapQ:hover {
    background-color: rgba(45, 117, 135, 0.08);
}

.lXpkr4DBNoBXh8uciTUg {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 15px;
    font-weight: 700;
    color: #1f2937;
}

.lXpkr4DBNoBXh8uciTUg i {
    font-size: 13px;
    color: var(--main-color-first);
}

.eHCebbragEljrkqMkUdu {
    font-size: 9px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: #8a949c;
    margin-top: 2px;
    white-space: nowrap;
}

/* Styles pour le texte enrichi */
.JZ2x49zwDi0LQQcTEfzq {
    min-height: 50px;
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
}

.JZ2x49zwDi0LQQcTEfzq p {
    margin: 0 0 8px 0;
}

.JZ2x49zwDi0LQQcTEfzq strong {
    font-weight: bold;
}

.JZ2x49zwDi0LQQcTEfzq em {
    font-style: italic;
}

.JZ2x49zwDi0LQQcTEfzq ins {
    text-decoration: underline;
}

.JZ2x49zwDi0LQQcTEfzq ul {
    padding-left: 20px;
    margin: 0 0 8px 0;
    list-style-type: disc !important;
}

.JZ2x49zwDi0LQQcTEfzq li {
    margin-bottom: 4px;
    list-style-type: disc !important;
}

.JZ2x49zwDi0LQQcTEfzq a {
    color: blue;
    text-decoration: underline;
}

/* globale pour cibler le popup du lien dans react-draft-wysiwyg */
.rdw-link-modal-target-option {
    display: none !important;
}

.dropify-wrapper input {
    height: 100% !important;
}

.yOgrXbDF16030i3UyGml{
    background: #FFFFFF !important;
}

.XcTLaoAiHsKNYrHzdS3w{
    position: absolute;
    top: 83px;
    height: 85vh;
    width: 100%;
    background-color: rgba(255,255,255,0.1);
    z-index: 1999;
}

.TulWyYUEWN_9RjOIQsjB{
    width: 100%!important;
    height: 400px;
    border: 1px #9a9a9a solid;
}

.LDD2Q5hgTlaPmQSzlqQ3 {
    text-transform: uppercase;
}

.wNEAJU9U4f26T_Ep3ahF {
    margin-bottom: 10px;
}

.qrRmtv93WjI2TUyBb9Sc {
    max-height: 80vh;
    overflow-x: hidden;
    overflow-y: auto;
}

.gTusB89GGH7d6Y0Ytezg {
    width: 440px;
    max-width: 100%;
}

.bwpRdQT3RKOT7SzoVfaq:disabled {
    opacity: 0.6;
    cursor: default;
    pointer-events: none;
}


.nfMcUJqu2Vi7HiUdofyL{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(200, 0, 0, 0.5);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    transition: opacity 0.3s;
}

/* État vide d'un tableau, avec action pour combler le vide */
.MbRjWNOOm5A921AAaFbg {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 36px 20px;
    text-align: center;
}

.hMbTN9ypRB4yjMn56nLW {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background-color: rgba(45, 117, 135, 0.1);
    color: var(--main-color-first);
    font-size: 22px;
    margin-bottom: 14px;
}

.iqdm8MBXid7QuHPFH5RQ {
    font-size: 14px;
    color: #6b7580;
    margin: 0 0 18px;
}

/* Gestionnaire de modèles d'entités */
.IdCavDpfAZjSWBdbLSiE {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100000;
}

.Y0cILOrDdWGbud3jbTx9 {
    background: #fff;
    padding: 24px;
    border-radius: 12px;
    min-width: 320px;
    max-width: 420px;
    box-shadow: 0 10px 30px rgba(0,0,0,0.25);
}

.Y0cILOrDdWGbud3jbTx9 .TY5Z8TzuMfxmDHE9pkFI {
    margin-top: 20px;
}

/* Saisie inline du nom de collection dans le tableau */
.aBFKbx0jWcAXvQxKZ6x_{
    width: 100% !important;
    box-sizing: border-box !important;
    padding: 0 8px !important;
    border: 1px solid var(--main-color-first) !important;
    border-radius: 6px !important;
    background-color: #fff !important;
    box-shadow: 0 0 0 3px rgba(45, 117, 135, 0.12) !important;
}

/* Boutons Annuler / Enregistrer en bas du formulaire d'entité */
.Z7TAEazerCPMA7SEu93K {
    margin-top: 20px;
    margin-bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/component/generale.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;EAUE,mDAAmD;AACrD;;AAEA;IACI,gCAAgC;IAChC,uBAAuB;IACvB,qBAAqB;IACrB,6BAA6B;IAC7B,+BAA+B;IAC/B,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,2CAA2C;IAC3C,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;;;;AAKA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA,qFAAqF;AACrF;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;IACrC,0CAA0C;IAC1C,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;IACzC,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,6CAA6C;AACjD;;AAEA;IACI,0CAA0C;IAC1C,sCAAsC;IACtC,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,8CAA8C;AAClD;;AAEA,8CAA8C;AAC9C;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,+BAA+B;AACnC;;AAEA;IACI,yCAAyC;IACzC,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ,EAAE,4BAA4B;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,0BAA0B;AAC9B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,uFAAuF;IACvF,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,uCAAuC;IACvC,mBAAmB;IACnB,WAAW;IACX,OAAO;IACP,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA,gDAAgD;AAChD;IACI,aAAa;IACb,oBAAoB;IACpB,QAAQ;IACR,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;IAC1B,uBAAuB;IACvB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,yCAAyC;IACzC,4CAA4C;AAChD;;AAEA;IACI,wCAAwC;IACxC,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,yCAAyC;AAC7C;;AAEA,oEAAoE;AACpE;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,4BAA4B;IAC5B,uBAAuB;IACvB,iCAAiC;IACjC,yBAAyB;IACzB,6BAA6B;IAC7B,yCAAyC;IACzC,0BAA0B;IAC1B,gBAAgB;IAChB,oBAAoB;IACpB,uDAAuD;IACvD,0BAA0B;AAC9B;;AAEA;IACI,qDAAqD;IACrD,qCAAqC;IACrC,yCAAyC;IACzC,2BAA2B;IAC3B,yDAAyD;AAC7D;;AAEA;IACI,eAAe;AACnB;;AAEA,gFAAgF;AAChF,qGAAqG;AACrG;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,sFAAsF;AACtF;IACI,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA,uDAAuD;AACvD;IACI,YAAY,EAAE,yDAAyD;IACvE,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA,8DAA8D;AAC9D;IACI,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,oBAAoB;IACpB,iCAAiC;IACjC,oCAAoC;IACpC,qCAAqC;IACrC,uDAAuD;AAC3D;;AAEA;IACI,sCAAsC;IACtC,gDAAgD;IAChD,qDAAqD;IACrD,yDAAyD;AAC7D;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,mDAAmD;AACnD;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,qCAAqC;IACrC,0CAA0C;IAC1C,2BAA2B;IAC3B,8CAA8C;AAClD;;AAEA,mDAAmD;AACnD;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA,yEAAyE;AACzE;IACI,aAAa;IACb,oBAAoB;IACpB,6BAA6B;IAC7B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA,iCAAiC;AACjC;IACI,gBAAgB;IAChB,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;AACpC;;AAEA;IACI,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA,kEAAkE;AAClE;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,WAAW;IACX,uCAAuC;IACvC,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,oBAAoB;AACxB;;;AAGA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA,6DAA6D;AAC7D;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yCAAyC;IACzC,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA,sCAAsC;AACtC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;AACpB;;AAEA,uDAAuD;AACvD;IACI,sBAAsB;IACtB,iCAAiC;IACjC,yBAAyB;IACzB,oDAAoD;IACpD,6BAA6B;IAC7B,iCAAiC;IACjC,yDAAyD;AAC7D;;AAEA,gEAAgE;AAChE;IACI,gBAAgB;IAChB,mBAAmB;AACvB","sourcesContent":[".familyFont,\n.familyFont p,\n.familyFont span,\n.familyFont div,\n.familyFont label,\n.familyFont td,\n.familyFont th,\n.familyFont input,\n.familyFont textarea,\n.familyFont select {\n  font-family: 'Titillium Web', sans-serif !important;\n}\n\n.selectCol {\n    display: inline-block !important;\n    height: auto !important;\n    opacity: 1 !important;\n    position: relative !important;\n    pointer-events: auto !important;\n    font-size: 14px !important;\n    height: 26px !important;\n    margin-bottom: 0 !important;\n    border: none !important;\n    border-bottom: 1px solid #9e9e9e !important;\n    padding: 0 !important;\n}\n\n.inputtCol{\n    font-size: 14px !important;\n    height: 26px !important;\n    margin-bottom: 0 !important;\n}\n\n.bold {\n    font-weight: bold !important;\n}\n\n.italic {\n    font-style: italic !important;\n}\n\n.fontSize15 {\n    font-size: 15px;\n}\n\n.fontSize13 {\n    font-size: 13px;\n}\n\n.fontSize14 {\n    font-size: 14px;\n}\n\n.fontSize15 {\n    font-size: 15px;\n}\n\n.fontSize16 {\n    font-size: 16px;\n}\n\n.fontSize18 {\n    font-size: 18px;\n}\n\n.fontSize20 {\n    font-size: 20px;\n}\n\n.fontSize22 {\n    font-size: 22px;\n}\n\n.fontSize24{\n    font-size: 24px;\n}\n\n.bgcolorfirst {\n    background-color: var(--main-color-first) !important;\n}\n\n.bgcolorfirsttext {\n    color: var(--main-color-first) !important;\n}\n\n.maincolorfirsttext {\n    color: var(--main-color-text-first) !important;\n}\n\n.noMargin {\n    margin: 0 !important;\n    padding: 0 !important;\n}\n\n\n\n\n.buttonfooter, .buttonfooterfrm{\n    text-align: center;\n    display: inline-block;\n    width:100%;\n}\n\n.buttonfooter button {\n    margin: 0 10px;\n}\n\n.buttonfooterfrm button {\n    margin: 0 5px;\n}\n\n/* Barre d'actions de modale (Annuler / Valider, etc.) : alignée à droite, compacte */\n.modalActions {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.modalBtn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 9px 20px;\n    border-radius: 8px;\n    font-size: 13px;\n    font-weight: 600;\n    border: 1px solid transparent;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.modalBtnSecondary {\n    background-color: #fff;\n    border-color: #e2e5e9;\n    color: var(--main-color-first);\n}\n\n.modalBtnSecondary:hover {\n    border-color: var(--main-color-first);\n    background-color: rgba(45, 117, 135, 0.08);\n    color: var(--main-color-first);\n}\n\n.modalBtnPrimary {\n    background-color: var(--main-color-first);\n    border-color: var(--main-color-first);\n    color: #fff;\n}\n\n.modalBtnPrimary:hover {\n    filter: brightness(1.08);\n    box-shadow: 0 3px 8px rgba(45, 117, 135, 0.3);\n}\n\n.modalBtnDanger {\n    background-color: var(--main-color-danger);\n    border-color: var(--main-color-danger);\n    color: #fff;\n}\n\n.modalBtnDanger:hover {\n    filter: brightness(1.05);\n    box-shadow: 0 3px 8px rgba(232, 102, 89, 0.35);\n}\n\n/* Icône + texte des modales de confirmation */\n.modalConfirmIcon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 48px;\n    height: 48px;\n    margin: 0 auto 14px;\n    border-radius: 50%;\n    font-size: 20px;\n}\n\n.modalConfirmIconDanger {\n    background-color: rgba(232, 102, 89, 0.12);\n    color: var(--main-color-danger);\n}\n\n.modalConfirmIconInfo {\n    background-color: rgba(45, 117, 135, 0.1);\n    color: var(--main-color-first);\n}\n\n.modalConfirmText {\n    text-align: center;\n    font-size: 15px;\n    line-height: 1.5;\n    color: #1f2937;\n    margin: 0;\n}\n\n.pickctn {\n    display: flex;\n    align-items: center;\n    gap: 4px; /* espace entre les inputs */\n}\n\n.pickctn input[type=\"color\"]{\n    width: 25px;\n    padding: 0px;\n    border:none;\n}\n\n.ctnFrmedi input{\n    height: 20px !important;\n    font-size: 12px !important;\n}\n\n.icomargin{\n    margin-right: 10px !important;\n}\n\n.icomarginObserv{\n    margin-left: 10px !important;\n    cursor: pointer;\n}\n\n.titleedsection{\n    margin-bottom: 10px !important;\n    text-transform: uppercase;\n}\n\n.titleedsection i{\n    color: var(--main-color-first);\n}\n\n.marginlr{\n    margin: 0px 5px !important;\n}\n\n.tooltipWrapper {\n    display: inline-block;\n    cursor: pointer;\n}\n\n.tooltipWrapperFull {\n    display: block;\n    width: 100%;\n    cursor: pointer;\n}\n\n.tooltipBubble {\n    position: absolute;\n    background: #3f3f3f;\n    color: white;\n    padding: 10px;\n    border-radius: 4px;\n    font-size: 15px;\n    z-index: 99999999;\n    width: max-content;\n    opacity: 1;\n    text-align: left;\n    white-space: pre-line;\n    line-height: 0.7;\n    /* La bulle recouvre souvent l'icône voisine : elle ne doit pas intercepter les clics */\n    pointer-events: none;\n}\n\n.ctnswitch {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.cnttblshared{\n    width: 50vw;\n    max-height: 50vh;\n    margin-top: 16px;\n}\n\n.ctnDisabled{\n    position: absolute;\n    background-color: rgba(255,255,255,0.1);\n    cursor: not-allowed;\n    z-index: 10;\n    left: 0;\n    width: 100%;\n    height: 98vh;\n}\n\n.ctnlistfichier{\n    width: 100%;\n    margin-top: 25px;\n    font-size: inherit !important;\n}\n\n.ctnlistfichier input{\n    font-size: inherit !important;\n}\n\n.sectionTitle{    \n    font-size: 13px;\n    font-style: italic;\n}\n\n/* Tabs as buttons : segmented control moderne */\n.tabsCtn{\n    display: flex;\n    align-items: stretch;\n    gap: 4px;\n    width: 100%;\n    box-sizing: border-box;\n    margin: 0 0 40px;\n    background-color: #eef1f3;\n    padding: 4px;\n    border-radius: 10px;\n    overflow-x: auto;\n}\n\n.tabBtn{\n    flex: 1 1 auto;\n    padding: 8px 6px;\n    border-radius: 7px;\n    text-decoration: none;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    gap: 5px;\n    font-size: 11px;\n    font-weight: 600;\n    letter-spacing: 0.1px;\n    line-height: 1.2;\n    white-space: nowrap;\n    transition: all 0.18s ease;\n    border: none !important;\n    outline: none !important;\n}\n\n.tabBtn i{\n    font-size: 12px;\n    flex-shrink: 0;\n}\n\n.tabBtnActive{\n    background-color: #ffffff !important;\n    color: var(--main-color-first) !important;\n    box-shadow: 0 1px 4px rgba(16, 24, 40, 0.14);\n}\n\n.tabBtnInactive{\n    background-color: transparent !important;\n    box-shadow: none !important;\n    color: #6b7580 !important;\n}\n\n.tabBtnInactive:hover{\n    color: var(--main-color-first) !important;\n}\n\n/* Bouton \"Retour\" (cohérent avec les boutons d'action du tableau) */\n.btnBack{\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 14px !important;\n    height: auto !important;\n    background-color: #fff !important;\n    border: 1px solid #e2e5e9;\n    border-radius: 8px !important;\n    color: var(--main-color-first) !important;\n    font-size: 13px !important;\n    font-weight: 600;\n    text-transform: none;\n    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05) !important;\n    transition: all 0.15s ease;\n}\n\n.btnBack:hover{\n    background-color: rgba(45, 117, 135, 0.08) !important;\n    border-color: var(--main-color-first);\n    color: var(--main-color-first) !important;\n    transform: translateY(-1px);\n    box-shadow: 0 3px 8px rgba(45, 117, 135, 0.18) !important;\n}\n\n.btnBack i{\n    font-size: 12px;\n}\n\n/* En-tête compact : nom de la collection + bouton Retour, sur une seule ligne */\n/* Collé en haut/gauche/droite du panneau : marges négatives pour compenser le gouttière du col s12 */\n.collectionHeaderBar{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 10px;\n    padding: 20px;\n    background: #eef1f3;\n    border: none;\n    border-radius: 0;\n    margin: 0 -0.75rem;\n}\n\n/* Variante pour un header affiché dans une modale (gouttière différente du col s12) */\n.collectionHeaderBarModal{\n    margin: -20px -20px 0;\n    border-radius: 10px 10px 0 0;\n}\n\n.mb40{\n    margin-bottom: 40px;\n}\n\n.collectionHeaderText{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    text-align: left;\n    min-width: 0;\n}\n\n.collectionHeaderLabel{\n    font-size: 10px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: #8a949c;\n}\n\n.collectionHeaderTitle{\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 15px;\n    font-weight: 700;\n    color: #1f2937;\n    line-height: 1.3;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.collectionHeaderTitle i{\n    font-size: 14px;\n    flex-shrink: 0;\n}\n\n/* Formulaire de marqueur avec hauteur fixe et scroll */\n.editFormContainer {\n    height: 100%; /* Hauteur ajustée pour laisser de la place aux boutons */\n    overflow-y: auto;\n    position: relative;\n    padding: 0px 11px;\n}\n\n.editFormSection {\n    padding: 15px;\n    background-color: whitesmoke;\n    border-radius: 10px;\n    border: 1px solid #bdbdbd;\n    margin-bottom: 8px;\n}\n\n.editFormSection input{\n    font-size: 14px !important;\n    height: 26px !important;\n    margin-bottom: 0 !important;\n}\n\n.editFormButtons {\n    position: sticky;\n    bottom: 0;\n    padding: 10px;\n    text-align: center;\n}\n\n.editFormButtons button {\n    width: 40% !important;\n    margin: 0 5px !important;\n}\n\n/* Barre d'outils au-dessus du formulaire d'édition d'entité */\n.buttonheaderfrm {\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    gap: 8px;\n    padding: 10px 16px;\n}\n\n.buttonheaderfrm button {\n    width: 36px !important;\n    height: 36px !important;\n    border-radius: 8px !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    margin: 0 !important;\n    background-color: #fff !important;\n    border: 1px solid #e2e5e9 !important;\n    transition: all 0.15s ease !important;\n    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.05) !important;\n}\n\n.buttonheaderfrm button:hover {\n    transform: translateY(-1px) !important;\n    border-color: var(--main-color-first) !important;\n    background-color: rgba(45, 117, 135, 0.08) !important;\n    box-shadow: 0 3px 8px rgba(45, 117, 135, 0.18) !important;\n}\n\n.buttonheaderfrm button i {\n    font-size: 16px !important;\n}\n\n/* Grille de sélection du type d'entité à ajouter */\n.entityTypeGrid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px;\n    padding: 6px 4px 10px;\n}\n\n.entityTypeBtn {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    padding: 14px 6px;\n    background-color: #fff;\n    border: 1px solid #e2e5e9;\n    border-radius: 10px;\n    cursor: pointer;\n    transition: all 0.15s ease;\n}\n\n.entityTypeBtn i {\n    font-size: 19px;\n    color: var(--main-color-first);\n}\n\n.entityTypeBtn span {\n    font-size: 12px;\n    font-weight: 600;\n    color: #1f2937;\n}\n\n.entityTypeBtn:hover {\n    border-color: var(--main-color-first);\n    background-color: rgba(45, 117, 135, 0.08);\n    transform: translateY(-1px);\n    box-shadow: 0 3px 8px rgba(45, 117, 135, 0.18);\n}\n\n/* En-tête de section secondaire (ex : \"Modèles\") */\n.sectionHeaderBar {\n    display: flex;\n    align-items: center;\n    padding: 12px 16px;\n    background: #eef1f3;\n    border-radius: 10px;\n    margin-top: 24px;\n    margin-bottom: 16px;\n}\n\n.sectionHeaderTitle {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.4px;\n    color: var(--main-color-first);\n}\n\n/* Barre de statistiques : pleine largeur, sous le header, sans encadré */\n.entityStatsContainer {\n    display: flex;\n    align-items: stretch;\n    justify-content: space-around;\n    margin-top: 8px;\n    margin-bottom: 40px;\n}\n\n.entityStatsContainer .contenuInfo {\n    flex: 1 1 0;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 8px 4px;\n    border-radius: 8px;\n    transition: background-color 0.15s ease;\n}\n\n.entityStatsContainer .contenuInfo:hover {\n    background-color: rgba(45, 117, 135, 0.08);\n}\n\n.statValue {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    font-size: 15px;\n    font-weight: 700;\n    color: #1f2937;\n}\n\n.statValue i {\n    font-size: 13px;\n    color: var(--main-color-first);\n}\n\n.statLabel {\n    font-size: 9px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.3px;\n    color: #8a949c;\n    margin-top: 2px;\n    white-space: nowrap;\n}\n\n/* Styles pour le texte enrichi */\n.observationPreview {\n    min-height: 50px;\n    padding: 5px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.observationPreview p {\n    margin: 0 0 8px 0;\n}\n\n.observationPreview strong {\n    font-weight: bold;\n}\n\n.observationPreview em {\n    font-style: italic;\n}\n\n.observationPreview ins {\n    text-decoration: underline;\n}\n\n.observationPreview ul {\n    padding-left: 20px;\n    margin: 0 0 8px 0;\n    list-style-type: disc !important;\n}\n\n.observationPreview li {\n    margin-bottom: 4px;\n    list-style-type: disc !important;\n}\n\n.observationPreview a {\n    color: blue;\n    text-decoration: underline;\n}\n\n/* globale pour cibler le popup du lien dans react-draft-wysiwyg */\n:global(.rdw-link-modal-target-option) {\n    display: none !important;\n}\n\n:global(.dropify-wrapper input) {\n    height: 100% !important;\n}\n\n.genbackground{\n    background: #FFFFFF !important;\n}\n\n.modalsetstyle{\n    position: absolute;\n    top: 83px;\n    height: 85vh;\n    width: 100%;\n    background-color: rgba(255,255,255,0.1);\n    z-index: 1999;\n}\n\n.modal_collection_map_modal{\n    width: 100%!important;\n    height: 400px;\n    border: 1px #9a9a9a solid;\n}\n\n.uppercase {\n    text-transform: uppercase;\n}\n\n.interbottom {\n    margin-bottom: 10px;\n}\n\n.modalCollFrm {\n    max-height: 80vh;\n    overflow-x: hidden;\n    overflow-y: auto;\n}\n\n.importParcFrm {\n    width: 440px;\n    max-width: 100%;\n}\n\n.modalBtn:disabled {\n    opacity: 0.6;\n    cursor: default;\n    pointer-events: none;\n}\n\n\n.gcdErrorUp{\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(200, 0, 0, 0.5);\n    color: white;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 14px;\n    font-weight: bold;\n    transition: opacity 0.3s;\n}\n\n/* État vide d'un tableau, avec action pour combler le vide */\n.emptyStateCtn {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 36px 20px;\n    text-align: center;\n}\n\n.emptyStateIcon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 56px;\n    height: 56px;\n    border-radius: 50%;\n    background-color: rgba(45, 117, 135, 0.1);\n    color: var(--main-color-first);\n    font-size: 22px;\n    margin-bottom: 14px;\n}\n\n.emptyStateText {\n    font-size: 14px;\n    color: #6b7580;\n    margin: 0 0 18px;\n}\n\n/* Gestionnaire de modèles d'entités */\n.modeleConfirmOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.5);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 100000;\n}\n\n.modeleConfirmBox {\n    background: #fff;\n    padding: 24px;\n    border-radius: 12px;\n    min-width: 320px;\n    max-width: 420px;\n    box-shadow: 0 10px 30px rgba(0,0,0,0.25);\n}\n\n.modeleConfirmBox .modalActions {\n    margin-top: 20px;\n}\n\n/* Saisie inline du nom de collection dans le tableau */\n.inlineNameInput{\n    width: 100% !important;\n    box-sizing: border-box !important;\n    padding: 0 8px !important;\n    border: 1px solid var(--main-color-first) !important;\n    border-radius: 6px !important;\n    background-color: #fff !important;\n    box-shadow: 0 0 0 3px rgba(45, 117, 135, 0.12) !important;\n}\n\n/* Boutons Annuler / Enregistrer en bas du formulaire d'entité */\n.editFormFooter {\n    margin-top: 20px;\n    margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"familyFont": `y7Nx7Cr1TtmW4ASo0VY5`,
	"selectCol": `jvBE8mURC_IdWYLHnXU4`,
	"inputtCol": `HQ8wAsiqfIbHQEBl8ynE`,
	"bold": `GXlT2h5vFwCjkhqZ1txQ`,
	"italic": `_2Ox8a9tL99eN3cfadyF`,
	"fontSize15": `HHT3NdpLsjB3wDdgFcyp`,
	"fontSize13": `xB5kMpnFA4CZPws0ZB3v`,
	"fontSize14": `Yd0yoKgLSxLwynjd1S4M`,
	"fontSize16": `ugBt4MGiOb2DFXqpRLyF`,
	"fontSize18": `bw0PA147IW7666x4KZfn`,
	"fontSize20": `De666OCGlMFmMIGbct1l`,
	"fontSize22": `HsXLb9fWOQc7h8XdKMt9`,
	"fontSize24": `tsX3cXEfxB9qqcyeccJl`,
	"bgcolorfirst": `X_0vxuuWb7FuISJr5ta9`,
	"bgcolorfirsttext": `xOz6IP2OVhytb_BEd_pa`,
	"maincolorfirsttext": `Yssvoyks3Tt_18WYq6Bq`,
	"noMargin": `NBhOJ47WfZNMFovOLBIi`,
	"buttonfooter": `ESsTQs0NRD0m9VcdjFKY`,
	"buttonfooterfrm": `iSN2Ll6PzRlwvLTP3PoR`,
	"modalActions": `TY5Z8TzuMfxmDHE9pkFI`,
	"modalBtn": `bwpRdQT3RKOT7SzoVfaq`,
	"modalBtnSecondary": `XozHTJq9bhHh72v5uSta`,
	"modalBtnPrimary": `_a2klPJRZf6smgbAypov`,
	"modalBtnDanger": `hMbelPjuLFPtLlLjmD7a`,
	"modalConfirmIcon": `BX9AoblnRBlgdKTLJjUS`,
	"modalConfirmIconDanger": `CJUEtrGlv92oMBAOvNCt`,
	"modalConfirmIconInfo": `S4SgwWg3XjLId_vicJrJ`,
	"modalConfirmText": `qqAvsH5DaVVLlpqyz2sA`,
	"pickctn": `UFyv3GYPGJ9NWKpEgM5D`,
	"ctnFrmedi": `Ge_14J3gaFWkhY7L8578`,
	"icomargin": `B532rq_23Pe9TF1PjzKH`,
	"icomarginObserv": `oeb38Hm18558EJlE2mci`,
	"titleedsection": `WESAR4jMpRrAWng01XH5`,
	"marginlr": `RbcSiMrUexvaQLlCo3z8`,
	"tooltipWrapper": `SLQOkMmQUALpvE7my4r6`,
	"tooltipWrapperFull": `pvTKSJb26xmQWrNB4Fix`,
	"tooltipBubble": `mBWaK0cEyX3MFXZ9pmmf`,
	"ctnswitch": `iQAPU9z2gCIQaymR3Y39`,
	"cnttblshared": `ozZgKYALSYKMZaU6MqxP`,
	"ctnDisabled": `GCkwjtQqCSEro4HTqmTm`,
	"ctnlistfichier": `n0NMaGXltW_TGBFncncp`,
	"sectionTitle": `CV7YlqDceeJw5hSAPGeu`,
	"tabsCtn": `Qu8WSNbuPEA3VUE0KoTp`,
	"tabBtn": `r1Oj_jrfoXY36ogdYUaX`,
	"tabBtnActive": `y3_2JBurG6RHs77ajIZj`,
	"tabBtnInactive": `reQwrlnWK8rXoFECVyHx`,
	"btnBack": `W35qku6J_CWwIAKZfzNq`,
	"collectionHeaderBar": `YXjsxIhICXJN1fxVxX3e`,
	"collectionHeaderBarModal": `OnZ394iI4tD8jgOo4DKe`,
	"mb40": `y8YILIq1_WEo9xmFCQhA`,
	"collectionHeaderText": `Y0RpztOUUIIs1qcIW_JX`,
	"collectionHeaderLabel": `za30F0kBx73Ng5KEEmb1`,
	"collectionHeaderTitle": `qRzkn2jXbRonbMxHQeH3`,
	"editFormContainer": `CKnnjqHED3JMrngXKPOF`,
	"editFormSection": `CjdCaJHB4l96gjlh0z1V`,
	"editFormButtons": `UatwlZ13jcublbROtyUH`,
	"buttonheaderfrm": `JMS38vIp_srUriL6JFhL`,
	"entityTypeGrid": `N2nwKnvqqzWTbYB0g1dm`,
	"entityTypeBtn": `VPJscFWb7cbA4tcpMNsz`,
	"sectionHeaderBar": `Zpqm6efEmphtU12aZuwC`,
	"sectionHeaderTitle": `KxSS26dTwN7YQ4ja_Mse`,
	"entityStatsContainer": `agXHbu9YBIQe6oJKDRnk`,
	"contenuInfo": `Y043oiZjvuQ3bcKEQapQ`,
	"statValue": `lXpkr4DBNoBXh8uciTUg`,
	"statLabel": `eHCebbragEljrkqMkUdu`,
	"observationPreview": `JZ2x49zwDi0LQQcTEfzq`,
	"genbackground": `yOgrXbDF16030i3UyGml`,
	"modalsetstyle": `XcTLaoAiHsKNYrHzdS3w`,
	"modal_collection_map_modal": `TulWyYUEWN_9RjOIQsjB`,
	"uppercase": `LDD2Q5hgTlaPmQSzlqQ3`,
	"interbottom": `wNEAJU9U4f26T_Ep3ahF`,
	"modalCollFrm": `qrRmtv93WjI2TUyBb9Sc`,
	"importParcFrm": `gTusB89GGH7d6Y0Ytezg`,
	"gcdErrorUp": `nfMcUJqu2Vi7HiUdofyL`,
	"emptyStateCtn": `MbRjWNOOm5A921AAaFbg`,
	"emptyStateIcon": `hMbTN9ypRB4yjMn56nLW`,
	"emptyStateText": `iqdm8MBXid7QuHPFH5RQ`,
	"modeleConfirmOverlay": `IdCavDpfAZjSWBdbLSiE`,
	"modeleConfirmBox": `Y0cILOrDdWGbud3jbTx9`,
	"inlineNameInput": `aBFKbx0jWcAXvQxKZ6x_`,
	"editFormFooter": `Z7TAEazerCPMA7SEu93K`
};
export default ___CSS_LOADER_EXPORT___;
